import styled from '@emotion/styled';
import ReactPhoneInput from 'react-phone-number-input';
import { INPUT_BOX } from '../Style/input';

export const StyledReactPhoneInput = styled(ReactPhoneInput)({
  display: 'flex',

  '.PhoneInputCountry': {
    position: 'relative',
    width: 55,
    height: 40,
    marginRight: 10,

    '.PhoneInputCountrySelect': {
      position: 'absolute',
      zIndex: 1,
      width: 55,
      height: 50,
      opacity: 0,
    },

    '.PhoneInputCountryIcon': {
      position: 'absolute',
      width: 40,
      top: 7,
    },

    '.PhoneInputCountryArrow': {
      position: 'absolute',
      right: 0,
      top: 12,
    },
  },

  '.PhoneInputInput': {
    ...INPUT_BOX,
    flex: 1,
    boxSizing: 'border-box',
  },
});
